export default __webpack_public_path__ + "static/media/halloween1.bd3a216d.png";